<template>
    <div class="modal fade" tabindex="-1" id="createReasonModal">
        <div class="modal-dialog">
          <form id="kt_modal_form_reason" @submit.prevent="addReason" class="form mt-5" >
            <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('button.add') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor"/>
                  </svg>
                </span>
              </div>
            </div>
            <div class="modal-body">
              <RequiredText />
                <div class="form d-flex flex-column mb-8 fv-row">
                  <Input
                      name="reason"
                      :label="$t('crm-setting.pipeline.losseReasons')"
                      :placeholder="$t('crm-setting.pipeline.losseReason.placeholder.addReason')"
                      v-model="reason"
                  />
                </div>
            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import { defineProps,ref } from 'vue';
import { useStore } from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import OutlineButton from "@/components/OutlineButton";
import Input from "@/components/Input";

const props = defineProps({
    formEdit:{
        type:Object,
        default:{}
    }
})

const store = useStore()

const reason = ref(null)

const isLoading = ref(false)

const emit = defineEmits(['reloadDatatable'])

function closeModal(){
  $('#createReasonModal').modal('toggle')
}

async function addReason() {
    isLoading.value = true
    try{
      await store.dispatch('reasons/createReason', {name: reason.value})
      window.toastr.success(i18n.global.t("notification.reason_created"))
      emit('reloadDatatable')
      reason.value=''
      isLoading.value = false
      $('#createReasonModal').modal('toggle')
    }catch(err){
      isLoading.value = false
    }
}

</script>